// If you are looking for functions or logic to change here, please see app-menu.jsx
import React from "react";
import { Button } from "@vitalsource/vstui";
import PropTypes from "prop-types";
import Dispatcher from "../../dispatcher";
import FractionStore from "../../stores/fraction-store";
import MainMenuMixin from "../ui_elements/main-menu-mixin";
import { VstLocales } from "vstui";
import GetAppModal from "../gadgets/src/mobile/getAppModal";
import AppMenu from "./app-menu";
import { TempMenu as Menu } from "../ui_elements/menu";
var MenuList = require("../ui_elements/menu-list");
var SearchContainer = require("../gadgets/src/search/search").class;
var Isvg = require("../../../vendor/react-inlinesvg");

class HeaderContainer extends AppMenu.Component {
  constructor(props) {
    super(props);
    this.state = {
      env: "header",
      largeMenu: true,
      selectedButton: false,
      licenseUpdating: false
    };
    this.headerListRef = React.createRef();
    this.logoRef = React.createRef();

    this._fractionStoreChange = this._fractionStoreChange.bind(this);
    this._userChange = this._userChange.bind(this);
    this._updateFilterTextValues = this._updateFilterTextValues.bind(this);
    this._toggleMainMenu = this._toggleMainMenu.bind(this);
    this._openSmsOrEmailModal = this._openSmsOrEmailModal.bind(this);
    this._clickShopNow = this._clickShopNow.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.getUser(
      function (user) {
        this.forceUpdate();
      }.bind(this),
      { skipAuth: true }
    );

    this.lastButtonWidth = 0;
    this._updateFilterTextValues();

    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(Dispatcher.USER_CHANGE, this._userChange);
    Dispatcher.bind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );

    $(window).on("resize orientationchange", this._updateFilterTextValues);
    $(window).on("resize orientationchange", function () {
      $("#search-container").css("height", $(window).height() - 58);
    });
    if (this.props.searchOnOpen) {
      $("#library-search-button").click();
      Fraction.Helpers.fireEvent("update-search-term", {
        value: this.props.searchOnOpen
      });
    }
  }

  componentWillUnmount() {
    $(window).unbind("resize");
    Fraction.Helpers.removeModal(() => {});
    Dispatcher.unbind(Dispatcher.USER_CHANGE, this._userChange);
    Dispatcher.unbind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 2);
  }

  componentDidUpdate() {
    $(".iconTitle").dotdotdot({
      ellipsis: "…",
      wrap: "letter",
      height: 30
    });
  }

  _fractionStoreChange() {
    this.setState({ licenseUpdating: FractionStore.get()["license-updating"] });
  }

  _userChange() {
    this.forceUpdate();
  }

  _updateFilterTextValues() {
    this.setState(
      { largeMenu: true, cutoff: false },
      function () {
        var logoWidth = Math.max(132, this.logoRef.current.offsetWidth);
        var buttonWidth = Math.max(
          this.lastButtonWidth,
          this.headerListRef.current.offsetWidth
        );
        this.lastButtonWidth = buttonWidth;
        var windowWidth = $(window).width();

        if (windowWidth >= logoWidth + buttonWidth + 50) {
          if (!this.state.largeMenu) {
            this.setState({ largeMenu: true, cutoff: false });
          }
        } else {
          if (this.state.largeMenu) {
            this.setState({ largeMenu: false, cutoff: windowWidth });
          }
        }
      }.bind(this)
    );
  }

  _toggleMainMenu(e) {
    Dispatcher.emit(Dispatcher.CLOSE_MENU);
    MainMenuMixin._toggleMainMenu(e, this.props.updatePowerByClass);
  }

  _openSmsOrEmailModal(e) {
    Dispatcher.emit(Dispatcher.CLOSE_MENU);
    Fraction.Helpers.showModal(
      {
        content: <GetAppModal />,
        closeCallback: () => {
          this.setState({ selectedButton: false });
        },
        definingClass: "mobile-apps",
        className: "mobile-apps-content",
        buttons: [],
        width: 500,
        height: 375,
        intersitial: true,
        title: i18n.t("mobile-apps.modal-header")
      },
      $(e.currentTarget)
    );
  }

  _clickShopNow(e) {
    if (Fraction.Brand.Store.shopNowURL) {
      e.preventDefault();
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.Store.shopNowURL,
        "_blank"
      );
    } else {
      this._clickStore(e);
    }
  }

  _getAppIcon(icon, iconLetter, customIcon) {
    switch (icon) {
      case "reader":
        return <Isvg className="icon reader" src="/img/circle_reader.svg" />;
      case "custom":
        return <Isvg className="icon custom" src={customIcon} />;
      case "arrow":
        return <Isvg className="icon arrow" src="/img/circle_arrow.svg" />;
      case "mobile":
        return <Isvg className="icon mobile" src="/img/circle_mobile.svg" />;
      case "default":
        return (
          <Isvg
            className={"icon letter-" + iconLetter}
            src="/img/global_nav_apps.svg"
          />
        );
      default:
        return (
          <Isvg
            className={"icon letter-" + iconLetter}
            src="/img/global_nav_apps.svg"
          />
        );
    }
  }

  renderAppDropdownFooter(deviceName) {
    let bookshelfName = "";
    if (Fraction.Helpers.isBookshelfBrand()) {
      bookshelfName = i18n.t("global-bar.bookshelf");
    }

    if (Fraction.Helpers.ReadOffline.shouldReadOffline()) {
      if (Fraction.Brand.ReadOffline.promoteMobile) {
        return (
          <button
            id="openMobileAppModal"
            className="apps-dropdown-footer-promote-mobile noButton"
            onClick={this._openSmsOrEmailModal}
          >
            {Fraction.Brand.Graphics.watkins && (
              <img src="/img/watkins_star.svg" />
            )}
            <div>
              <h4>{i18n.t("mobile-apps.read-on-the-go")}</h4>
              <p>{i18n.t("mobile-apps.get-link-sms-only")}</p>
            </div>
            <Isvg src="/img/arrow_lg.svg" />
          </button>
        );
      } else {
        return (
          <div className="apps-dropdown-footer">
            <span>
              <p>
                {i18n.t("main-menu.read-offline-text", {
                  bookshelf: bookshelfName,
                  device: Fraction.Helpers.Browser.deviceCheck()
                })}
              </p>
              <Button
                className={
                  "read-offline " + Fraction.Helpers.Browser.deviceCheck()
                }
                href="#"
                target="_blank"
                onClick={this._downloadApp}
              >
                <span>{i18n.t("main-menu.download")}</span>
              </Button>
            </span>
          </div>
        );
      }
    }
  }

  _updateLocale(locale) {
    Jigsaw.User.setInfo({ locale }, () => {
      window.location.reload();
    });
  }

  _clickLocales() {
    return (
      <VstLocales
        customText={i18n.t("base.language-choice")}
        customX={284}
        customY={-15}
        onChange={this._updateLocale}
        selected={i18n.getCurrentLocale()}
        vertical={"top"}
        hidden={true}
      />
    );
  }

  render() {
    var headerList;
    var headerPadding = "";

    if (this.props.positionState === 1) {
      headerPadding = "large-padding";
    } else if (this.props.positionState > 1) {
      headerPadding = "small-padding";
    }

    if (!this.props.hide) {
      var userInfoItems = [];
      var appDropDownItems = [];
      var toolsItems = [];

      if (Fraction.User) {
        if (Fraction.Helpers.Users.isFullAccountUser()) {
          userInfoItems.push({
            html: (
              <li key="user-full-name" className="user-full-name">
                <span>
                  {Fraction.User.firstName} {Fraction.User.lastName}
                </span>
              </li>
            )
          });
          userInfoItems.push({
            html: (
              <li key="user-email-address" className="user-email-address">
                <span>{Fraction.User.email}</span>
              </li>
            )
          });
        }
        if (this.shouldShowCompleteAccount()) {
          userInfoItems.push({
            html: (
              <li key="complete-your-account">
                <button
                  onClick={this._completeAccount}
                  className="complete-your-account"
                >
                  {i18n.t("sso.complete-your-account")}
                </button>
              </li>
            )
          });
        }
        if (this.shouldShowOptOut()) {
          userInfoItems.push({
            html: (
              <li key="opt-out" className="context-menu-option opt-out">
                <a onClick={this._clickOptOut} className="noButton">
                  <span>{i18n.t("main-menu.opt-out")}</span>
                </a>
              </li>
            )
          });
        }
        if (this.shouldShowUserInfo()) {
          userInfoItems.push({
            key: "manage-account",
            userLabel: (
              <span className="manage-account">
                {i18n.t("main-menu.manage-account")}
              </span>
            ),
            clickEvent: this._clickUserInfo,
            target: "_blank"
          });
        }
        userInfoItems.push({
          html: <li id="change-language">{this._clickLocales()}</li>
        });
        if (this.shouldShowDevices()) {
          userInfoItems.push({
            key: "device",
            userLabel: (
              <span className="device-item">{i18n.t("main-menu.devices")}</span>
            ),
            clickEvent: this._clickDevices,
            target: "_blank"
          });
        }
        if (this.shouldShowPOD()) {
          userInfoItems.push({
            key: "print",
            userLabel: (
              <span className="pod-item">
                {i18n.t("main-menu.print-on-demand")}
              </span>
            ),
            clickEvent: this._clickPOD,
            target: "_blank"
          });
        }
        if (this.shouldShowResources()) {
          userInfoItems.push({
            key: "resources",
            userLabel: (
              <span className="resources-item">
                {i18n.t("main-menu.resources")}
              </span>
            ),
            clickEvent: this._clickResources,
            target: "_blank"
          });
        }
        if (this.shouldShowFeedback()) {
          userInfoItems.push({
            key: "feedback",
            userLabel: (
              <span className="feedback-item">
                {i18n.t("global-bar.feedback")}
              </span>
            ),
            clickEvent: this._takeSurvey
          });
        }
        if (this.shouldShowAbout()) {
          userInfoItems.push({
            key: "about",
            userLabel: (
              <span className="account-about">
                {Fraction.Helpers.isBookshelfBrand()
                  ? i18n.t("main-menu.about-bookshelf")
                  : Fraction.Brand.About.label || i18n.t("global-bar.about")}
              </span>
            ),
            clickEvent: this._clickAbout,
            target: "_blank"
          });
        }
        if (this.shouldShowPrivacy()) {
          userInfoItems.push({
            key: "privacy",
            userLabel: (
              <span className="resources-item">
                {i18n.t("main-menu.privacy")}
              </span>
            ),
            clickEvent: this._clickPrivacy,
            target: "_blank"
          });
        }
        if (this.shouldShowTerms()) {
          userInfoItems.push({
            key: "terms",
            userLabel: (
              <span className="resources-item">
                {i18n.t("main-menu.terms")}
              </span>
            ),
            clickEvent: this._clickTerms
          });
        }
        if (this.shouldShowLogout()) {
          userInfoItems.push({
            html: (
              <li
                key="account-sign-out"
                className="context-menu-option account-sign-out"
              >
                <a onClick={this._logOut} href="#" className="noButton">
                  <span>{i18n.t("global-bar.sign-out")}</span>
                </a>
              </li>
            )
          });
        }
      }
      // dotted square header item with app icons
      if (this.shouldShowLibrary()) {
        appDropDownItems.push({
          key: "bookshelf",
          userLabel: (
            <span className="bookshelf-item">
              {this._getAppIcon(
                Fraction.Brand.Bookshelf.icon,
                Fraction.Brand.Bookshelf.iconLetter,
                Fraction.Brand.Bookshelf.customIcon
              )}
              <span className="iconTitle">
                {Fraction.Brand.Bookshelf.label || Fraction.Brand.brand}
              </span>
            </span>
          ),
          clickEvent: this._clickBookshelf
        });
      }
      if (Fraction.Helpers.ReadOffline.shouldReadOffline()) {
        appDropDownItems.push({
          key: "bookshelf-desktop",
          userLabel: (
            <span className="bookshelf-desktop-item">
              {this._getAppIcon(
                Fraction.Brand.Bookshelf.icon,
                Fraction.Brand.Bookshelf.iconLetter,
                Fraction.Brand.Bookshelf.customIcon
              )}
              <span className="iconTitle">
                {i18n.t("global-bar.device-app", {
                  device: Fraction.Helpers.Browser.deviceCheck()
                })}
              </span>
            </span>
          ),
          clickEvent: this._launchInApp,
          target: "_blank"
        });
      }
      if (Fraction.Brand.Store.visible) {
        appDropDownItems.push({
          key: "store",
          userLabel: (
            <span className="store-item">
              {this._getAppIcon(
                Fraction.Brand.Store.icon,
                Fraction.Brand.Store.iconLetter,
                Fraction.Brand.Store.customIcon
              )}
              <span className="iconTitle">
                {Fraction.Brand.Store.label || i18n.t("global-bar.store")}
              </span>
            </span>
          ),
          clickEvent: this._clickStore,
          target: "_blank"
        });
      }
      if (this.shouldShowSupport()) {
        appDropDownItems.push({
          key: "support",
          userLabel: (
            <span className="support-item">
              {this._getAppIcon(
                Fraction.Brand.Support.icon,
                Fraction.Brand.Support.iconLetter,
                Fraction.Brand.Support.customIcon
              )}
              <span className="iconTitle">
                {Fraction.Brand.Support.label || i18n.t("global-bar.support")}
              </span>
            </span>
          ),
          clickEvent: this._clickSupport,
          target: "_blank"
        });
      }

      // We've removed the score center app button for now
      if (false && this.shouldShowScoreCenter()) {
        appDropDownItems.push({
          key: "score_center",
          userLabel: (
            <span className="score-center-item">
              {this._getAppIcon(
                Fraction.Brand.ScoreCenter.icon,
                Fraction.Brand.ScoreCenter.iconLetter
              )}
              <span className="iconTitle">
                {Fraction.Brand.ScoreCenter.label ||
                  i18n.t("global-bar.score_center")}
              </span>
            </span>
          ),
          clickEvent: this._clickScoreCenter,
          target: "_blank"
        });
      }

      if (this.shouldShowVstAnalytics()) {
        appDropDownItems.push({
          key: "vst-analytics",
          userLabel: (
            <span className="vst-analytics-item">
              {this._getAppIcon(
                Fraction.Brand.VstAnalytics.icon,
                Fraction.Brand.VstAnalytics.iconLetter,
                Fraction.Brand.VstAnalytics.customIcon
              )}
              <span className="iconTitle">
                {Fraction.Brand.VstAnalytics.label ||
                  i18n.t("global-bar.vst-analytics")}
              </span>
            </span>
          ),
          clickEvent: this._clickVstAnalytics,
          target: "_blank"
        });
      }

      Fraction.Brand.AppMenu.elements.forEach(element => {
        if (element.enabled) {
          appDropDownItems.push({
            key: element.key || element.label,
            userLabel: (
              <span className="app-menu-item">
                {this._getAppIcon(
                  element.customIcon ? "custom" : undefined,
                  element.iconLetter,
                  element.customIcon
                )}
                <span className="iconTitle">{element.label}</span>
              </span>
            ),
            clickEvent: e => {
              this._clickAppMenuElement(e, element);
            }
          });
        }
      });

      var appDropDownPlaceholder = appDropDownItems.length % 3;
      for (var i = 0; i < (3 - appDropDownPlaceholder) % 3; i++) {
        appDropDownItems.push({
          html: (
            <li
              key={"placeholder-icon-" + i}
              aria-hidden="true"
              className="context-menu-option placeholder-icon"
            >
              <span>
                <Isvg className="icon" src="/img/global-nav_blank.svg" />
                <span className="offScreen">
                  {i18n.t("global-bar.placeholder")}
                </span>
              </span>
            </li>
          )
        });
      }

      if (this.shouldShowSharing()) {
        toolsItems.push({
          label:
            "<div className='sharing-item'>" +
            i18n.t("main-menu.sharing") +
            "</div>",
          id: "sharing-button",
          clickEvent: this._clickSharing
        });
      }
      if (this.shouldShowHighlighters()) {
        toolsItems.push({
          label:
            "<div className='highlighters-item'>" +
            i18n.t("main-menu.highlighters") +
            "</div>",
          id: "highlighters-button",
          clickEvent: this._clickHighlighters
        });
      }
      if (this.shouldShowUpdateLicense()) {
        toolsItems.push({
          label:
            "<div className='update-item'>" +
            i18n.t("main-menu.update") +
            "</div>",
          id: "update-license-button",
          clickEvent: this._updateLicense
        });
      }
      if (this.shouldShowFacultyUpload()) {
        toolsItems.push({
          label:
            "<div className='faculty-upload-item'>" +
            i18n.t("main-menu.faculty-upload") +
            "</div>",
          id: "faculty-upload-button",
          clickEvent: this._facultyUpload
        });
      }

      headerList = (
        <span>
          <ul ref={this.headerListRef} className="header-list" role="navigation">
            {Fraction.Brand.Store.visible && Fraction.Brand.Store.shopNow && (
              <li className="store-item">
                <a
                  href="#"
                  className="noButton"
                  target="_blank"
                  onClick={this._clickShopNow}
                >
                  {i18n.t("global-bar.shop-now")}
                </a>
              </li>
            )}
            {Fraction.Brand.Menu.redeem && (
              <li className="redeem-item">
                <button className="noButton" onClick={this._redeem}>
                  {i18n.t("global-bar.redeem")}
                </button>
              </li>
            )}
            {toolsItems.length > 0 && (
              <li id="user-dropdown-dom" className="tools-item">
                <Menu
                  id="user-dropdown-menu"
                  button={{
                    id: "tools-button",
                    render: "global-bar.tools"
                  }}
                  openReport="header/user-show"
                  closeReport="header/user-hide"
                >
                  <MenuList key="tools-menu-list" items={toolsItems} />
                </Menu>
              </li>
            )}
            {Fraction.Brand.Library.search && (
              <li id="library-search-dom" className="search-item">
                <Menu
                  id="search-dropdown-menu"
                  button={{
                    id: "library-search-button"
                  }}
                  mobileModal={{
                    title: false,
                    content: (
                      <SearchContainer
                        modalHeader={true}
                        noFilter={true}
                        searchOnOpen={this.props.searchOnOpen}
                      />
                    ),
                    definingClass: "search-modal-outer",
                    className: "search-modal",
                    buttons: [],
                    fullscreen: true,
                    width: "100%",
                    height: 560,
                    intersitial: true
                  }}
                  offScreen="base.search"
                  openReport={[
                    "V3/library-search",
                    "search:click",
                    "openLibrarySearch"
                  ]}
                  closeReport={[
                    "V3/library-search",
                    "search:close",
                    "closeLibrarySearch"
                  ]}
                >
                  <SearchContainer
                    noFilter={true}
                    searchOnOpen={this.props.searchOnOpen}
                  />
                </Menu>
              </li>
            )}
            <li id="apps-dropdown-dom" className="apps-item">
              <Menu
                id="apps-dropdown-menu"
                offScreen="global-bar.apps"
                openReport="header/apps-show"
                closeReport="header/apps-hide"
              >
                <div className="apps-dropdown">
                  <MenuList
                    key="user-info-menu-list"
                    items={appDropDownItems}
                  />
                </div>
                {this.renderAppDropdownFooter(
                  Fraction.Helpers.Browser.deviceCheck()
                )}
              </Menu>
            </li>
            <li id="user-dropdown-dom-1" className="account-item">
              <Menu
                id="user-dropdown-menu-1"
                offScreen="global-bar.account"
                openReport="header/user-show"
                closeReport="header/user-hide"
              >
                <div className="account-dropdown">
                  <MenuList key="user-info-menu-list" items={userInfoItems} />
                </div>
              </Menu>
            </li>
          </ul>
        </span>
      );
    } else {
      headerList = (
        <ul ref={this.headerListRef} className="header-list-signin">
          {Fraction.Brand.Store.visible && !Fraction.Helpers.isSmallScreen() && (
            <li className="store-item">
              <a
                href={Fraction.Brand.Store.url}
                target="_blank"
                onClick={this._clickStore}
              >
                {Fraction.Brand.Store.label || i18n.t("global-bar.store")}
              </a>
            </li>
          )}
          {Fraction.Brand.Support.visible && (
            <li className="support-item">
              <a
                href={Fraction.Brand.Support.url}
                target="_blank"
                onClick={this._clickSupport}
              >
                {Fraction.Brand.Support.label || i18n.t("global-bar.support")}
              </a>
            </li>
          )}
        </ul>
      );
    }

    return (
      <header
        aria-hidden={FractionStore.get()["modal-open"]}
        className={headerPadding + (this.state.largeMenu ? "" : " small-menu")}
      >
        <div aria-hidden={FractionStore.get()["modal-open"]} className="left">
          <button
            className="menu-icon menu-button"
            onClick={this._toggleMainMenu}
          >
            <Isvg src="/img/menu.svg" />
            <span>{i18n.t("reader.buttons.main-menu")}</span>
          </button>

          <div id="logo">
            {this.props.disableLink ? (
              <div>
                <img
                  ref={this.logoRef}
                  src={Fraction.Brand.Graphics.logo}
                  alt="Bookshelf Home"
                />
              </div>
            ) : (
              <a href="/#/" onClick={this._libraryButton}>
                <img
                  ref={this.logoRef}
                  src={Fraction.Brand.Graphics.logo}
                  alt="Bookshelf Home"
                />
              </a>
            )}
          </div>

          {headerList}
        </div>
        {this.state.licenseUpdating && <div className="subtle-loader" />}
      </header>
    );
  }
}

HeaderContainer.propTypes = {
  searchOnOpen: PropTypes.bool,
  assignmentCreatorOpen: PropTypes.bool,
  updatePowerByClass: PropTypes.func,
  positionState: PropTypes.number,
  hide: PropTypes.bool,
  disableLink: PropTypes.bool
};
HeaderContainer.defaultProps = {
  searchOnOpen: false,
  assignmentCreatorOpen: false,
  updatePowerByClass: () => {},
  positionState: 1,
  hide: false,
  disableLink: false
};

module.exports = HeaderContainer;
